module.exports = __webpack_public_path__ + "static/media/count25_118.3d570842.png";